import { render } from "./Target.vue?vue&type=template&id=08ffe741"
import script from "./Target.vue?vue&type=script&setup=true&lang=js"
export * from "./Target.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Target.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08ffe741"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08ffe741', __exports__)) {
    api.reload('08ffe741', __exports__)
  }
  
  module.hot.accept("./Target.vue?vue&type=template&id=08ffe741", () => {
    api.rerender('08ffe741', render)
  })

}


export default __exports__